import "./WhatIsTaiChi.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Introduction from "./sections/Introduction";
import Benefits from "./sections/Benefits";
import OurForms from "./sections/OurForms";
import Footer from "@/reusable_sections/Footer";
export default function WhatIsTaiChiPage() {
  return <div>
      <Header />
      <Hero />
      <Introduction />
      <Benefits />
      <OurForms />
      <Footer />
    </div>;
}